import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { AppDirection } from '@/enums/app-direction';
import { useConstantStore, useFilterStore, useMetaStore } from '@/helpers/composables/useStores';
import { FilterCollection } from '@/stores/filter.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvidersButton',
  props: {
    userProvidersOnly: { type: Boolean, default: false },
    size: { default: 'regular' }
  },
  setup(__props: any) {

const props = __props as { userProvidersOnly: boolean, size: 'regular' | 'large' };

const regularButtonWidth = 64;
const regularButtonHeight = 32;
const regularProviderIconWidth = 16;
const halfRegularProviderIconWidth = regularProviderIconWidth / 2;

const largeButtonWidth = 80;
const largeButtonHeight = 40;
const largeProviderIconWidth = 20;
const halfLargeProviderIconWidth = largeProviderIconWidth / 2;



const { providersByShortName } = useConstantStore();
const { currentFilters, selectedProvidersType, selectedProvidersByType } = useFilterStore();
const { appDirection } = useMetaStore();

const providers = computed(() => {
	if (props.userProvidersOnly) {
		return selectedProvidersByType.value('my_services');
	}

	if (currentFilters.value.providers.length) {
		return (currentFilters.value as FilterCollection).providers.map(
			(shortName: string) => providersByShortName.value[shortName]
		);
	}

	return selectedProvidersByType.value(selectedProvidersType.value);
});

const providersToDisplay = computed(() => providers.value.slice(0, 5));

const isRTL = computed((): boolean => {
	return appDirection.value === AppDirection.RTL;
});

const selectedProvidersCount = computed(() => {
	const filteredProvidersCount = currentFilters.value.providers.length;

	if (filteredProvidersCount && !props.userProvidersOnly) {
		return `${filteredProvidersCount}/${selectedProvidersByType.value(selectedProvidersType.value).length}`;
	}

	return providers.value.length;
});

const buttonHeight = computed(() => {
	return props.size === 'large' ? largeButtonHeight : regularButtonHeight;
});

const buttonWidth = computed(() => {
	return props.size === 'large' ? largeButtonWidth : regularButtonWidth;
});

const providerIconWidth = computed(() => {
	return props.size === 'large' ? largeProviderIconWidth : regularProviderIconWidth;
});

const halfProviderIconWidth = () => {
	return props.size === 'large' ? halfLargeProviderIconWidth : halfRegularProviderIconWidth;
};

const buttonStyles = computed(() => {
	return {
		width: `${props.size === 'large' ? largeButtonWidth : regularButtonWidth}px`,
		height: `${props.size === 'large' ? largeButtonHeight : regularButtonHeight}px`,
	};
});

const isActive = computed(() => {
	return selectedProvidersType.value !== 'all' || currentFilters.value.providers.length > 0;
});
function providerStyles(index: number) {
	return {
		top: `${(buttonHeight.value - providerIconWidth.value) / 2}px`,
		[isRTL.value ? 'right' : 'left']: `${providerIconPosition(index)}px`,
		width: `${props.size === 'large' ? largeProviderIconWidth : regularProviderIconWidth}px`,
		height: `${props.size === 'large' ? largeProviderIconWidth : regularProviderIconWidth}px`,
	};
}

function providerIconPosition(index: number) {
	return providersToDisplay.value.length % 2
		? // center the central icon (e.g., the 2nd if 3 icons, the 3rd if 5)
		  (buttonWidth.value - providerIconWidth.value) / 2 -
				halfProviderIconWidth() * Math.floor(providersToDisplay.value.length / 2) +
				index * halfProviderIconWidth()
		: // center the space between the 2 central icons (e.g., between 2nd and 3rd if 4 icons)
		  (buttonWidth.value - halfProviderIconWidth()) / 2 -
				halfProviderIconWidth() * (providersToDisplay.value.length / 2 - index);
}

return { __sfc: true,regularButtonWidth, regularButtonHeight, regularProviderIconWidth, halfRegularProviderIconWidth, largeButtonWidth, largeButtonHeight, largeProviderIconWidth, halfLargeProviderIconWidth, props, providersByShortName, currentFilters, selectedProvidersType, selectedProvidersByType, appDirection, providers, providersToDisplay, isRTL, selectedProvidersCount, buttonHeight, buttonWidth, providerIconWidth, halfProviderIconWidth, buttonStyles, isActive, providerStyles, providerIconPosition, ProviderIcon }
}

})